import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { WorkOfferLookupComponent } from './work-offer-lookup.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [WorkOfferLookupComponent],
  exports: [WorkOfferLookupComponent],
  providers: []
})
export class WorkOfferLookupModule { }
